export default __webpack_public_path__ + "static/media/CO2.e22b9656.svg";